<div #mapContainer class="here-map flex basis-full" ></div>
